import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import App from 'pages/App';
import muiTheme from 'themes/muiTheme';
import reportWebVitals from './reportWebVitals';
import './index.scss';

// eslint-disable-next-line react/no-deprecated
// @ts-ignore — using React 17 ReactDOM.render; @types/react-dom ≥18 omits it
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
